<template lang="pug">
  div.map-popup
    // tooltip--bottom - тублип снизу от объекта (стрелка сверху)
        // tooltip--top - тублип сверху от объекта (стрелка снизу)
        // tooltip--left - тублип слева от объекта (стрелка справа)
        // tooltip--right - тублип справа от объекта (стрелка слева)
    div(v-if="loading")
      div.tooltip__head
        p.title Загрузка...
        span(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body
        div.spinner
          div.rect1
          div.rect2
          div.rect3
          div.rect4
          div.rect5
    div(v-else-if="error")
      div.tooltip__head
         p.title Ошибка
         span(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body {{error}}
    div(v-else-if="!loading")
      div.tooltip__head
        p.title {{head}}
        span(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body
        popup-fields-rows(:rows="rows" :model="fields")
        // div.tooltip__body-table
          div.table
            table
              thead
                th Технология
                th Мощность
                th Пришло
              tbody
                tr
                  td Рециклинг
                  td n/a
                  td n/a
        // div.tooltip__body-bar
          div Загрузка объекта: n/a%
          div.progressbar
            div.progressbar.progressbar--loaded(style="width: 64%;")
        button(
          v-if="fields.photo_id"
          @click="showPhoto = !showPhoto"
        ).standart.blue {{ !showPhoto ? 'Показать фото' : 'Скрыть фото' }}
        e-simple-file-uploader(
          v-show="showPhoto"
          name="photoPreview"
          tab-view="1"
          :model="fields"
          :read-only="true"
        )
      div.tooltip__foot
        button(v-if="showMore" @click.prevent="more") Подробнее
</template>

<script>
  import baseMapPopupMixin from './base-map-popup-mixin.js'
  import PopupFieldsRows from './popup-fields-rows.vue'
  
  import {ICON_TYPE_ROUTE_NAME_MAP} from '@/config/map'
  /*
   active  - зеленый
   planned - желтый

   */
  export default {
    components: {PopupFieldsRows},
    mixins: [baseMapPopupMixin],
    name: 'map-popup',
    data () {
      this.closeCallback = null
      return {
        downloadedFiles: {},
        showPhoto: false
      }
    },
    props: {
      id: {
        type: Number,
        default: 0
      },
      layerConfig: {
        type: Object,
        default: function () {
          return {
            endpoint: null
          }
        }
      },
      subLayerConfig: {
        type: Object,
        default: function () {
          return {
            iconType: null
          }
        }
      }
    },
    methods: {
      injectConf (options) {
        let {id, layerConfig = {}, model = {}, subLayerConfig = {showMore: !this.$sharedServices.store.getters.isGuest}, closeCallback} = options
        if (subLayerConfig.hasOwnProperty('showMore')) {
          this.showMore = subLayerConfig.showMore
        }
        this.showMore =  !this.$sharedServices.store.getters.isGuest
        this.layerConfig = layerConfig || model.layerConfig
        this.subLayerConfig = subLayerConfig || model.subLayerConfig
        this.id = id || model.id
        this.closeCallback = closeCallback
        this.fetchData()
        this.registerVueInMap()
      },
      close ($event) {
        this.closeCallback($event)
      },
      registerClosePopup () {

      },
      fetchData () {
        console.log('fetchData', this)
        if (this.id && this.layerConfig && this.subLayerConfig && (this.subLayerConfig.endpoint || this.layerConfig.endpoint)) {
          let usedEndpoint = this.subLayerConfig.endpoint || this.layerConfig.endpoint
          let endpoint = typeof usedEndpoint === 'function' ? usedEndpoint(null, {
            query: {
              id: this.id
            }
          }) : usedEndpoint
          this.fetchGeoObjectPopupData(endpoint)
        } else {
          throw new Error('Wrong data')
        }
      }
    }
  };
</script>
